import { types, getParent } from 'mobx-state-tree';
import shortid from 'shortid';
// import localforage from 'localforage';

// const store = localforage.createInstance({ name: 'standardOperations' })

export default types.model({
  id: types.identifier(types.string),
  description: '',
  minutesPerSetup: 60,
  secondsPerOperation: 60
}).preProcessSnapshot(snapshot => {
  const copy = Object.assign(snapshot)
  if (!copy.id) copy.id = shortid.generate()
  return copy
}).views(self => ({
  get isValid() {
    return (
      self.description.length > 0
      && self.minutesPerSetup > -1
      && self.secondsPerOperation > -1
    )
  },
  get setupTimeAsString() {
    return self.minutesPerSetup + ' min'
  },
  get operationTimeAsString() {
    return self.secondsPerOperation + ' sec'
  },
})).actions(self => ({
  save() {
    // store.setItem(self.id, getSnapshot(self))
    getParent(self, 2).saveItem(self)
  },
  setDescription(description) {
    self.description = description
  },
  setSetupTime(minutes) {
    self.minutesPerSetup = minutes
  },
  setOperationTime(seconds) {
    self.secondsPerOperation = seconds
  },
}))


// WEBPACK FOOTER //
// ./src/models/StandardOperation.js